<template>
  <div>
    <h1 v-if="userId == null">Benutzer erstellen</h1>
    <h1 v-if="userId != null">Benutzer bearbeiten</h1>

    <div v-if="dataLoaded || userId == null" @submit.prevent="login">
      <div class="row">
        <div class="col-12" v-if="userId != null">
          Änderungen gespeichert: <input v-model="checked" class="checkbox-saved" data-id="user.id" disabled="disabled" type="checkbox" />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Username</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.userName" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Email</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.email" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Vorname</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.firstName" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Nachname</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.lastName" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="control-label col-md-4">Geburtstag</label>
            <div class="col-md-8">
              <datepicker @input="putUser" v-model="user.birthDate" class="text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Stadt</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.city" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">PLZ</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.zip" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Straße</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.street" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Hausnummer</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.streetNumber" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Versicherungsstatus</label>
            <div class="col-md-8">
              <select v-on:change="putUser" v-model="user.socialInsuranceStatusId" class="form-control">
                <option v-if="insuranceStatiLoaded" v-for="insuranceStatus in insuranceStati" v-bind:value="insuranceStatus.id">
                  {{insuranceStatus.name}}
                </option>
                <option v-else>...</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Nationalität</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.nationality" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Beitrittsdatum</label>
            <div class="col-md-8">
              <datepicker @input="putUser" v-model="user.entryDate" class="text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Austrittsdatum</label>
            <div class="col-md-8">
              <datepicker :clear-button="true" @input="putUser" v-model="user.leaveDate" class="text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Urlaubsabgeltung</label>
            <div class="col-md-8">
              <input v-on:change="putUser" type="checkbox" v-model="user.paymentInLieuOfVacation" class="form-control" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Urlaubstage/Jahr</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.leaveDaysPerYear" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
          <div class="col-6">
            <div class="form-group">
              <label class="control-label col-md-6">Urlaubstage 2020</label>
              <div class="col-md-8">
                <input @input="putUser" v-model="user.carryForwardLeaves" class="form-control text-box single-line" />
              </div>
            </div>
          </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Arbeitsstunden/Woche</label>
            <div class="col-md-8">
              <input @input="putUser" v-model="user.workingHoursPerWeek" class="form-control text-box single-line" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="control-label col-md-4">Probezeit</label>
            <div class="col-md-8">
              <datepicker :clear-button="true" @input="putUser" v-model="user.probationTimeUntil" class="text-box single-line" />
            </div>
          </div>
        </div>
      </div>
      <DifferentHours :user="user"/>

      <div class="row" v-if="userId == null" >
        <div class="col-6">
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="col-md-8">
              <button v-on:click="createUser" class="btn btn-info">Erstellen</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-else>
      ...
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import datepicker from "vuejs-datepicker";
  import DifferentHours from "../differentHours/index.vue"


  export default {
    components: {
      datepicker,
      DifferentHours
    },
    name: "userDetails",
    data: function () {
      return {
        checked: true,
        userId: "",
        user: {},
        dataLoaded: false,
        insuranceStati: [],
        insuranceStatiLoaded: false
      }
    },
    created: function () {
    },
    methods: {
      putUser: function (event) {
        if(this.userId == null) {
          return;
        }

        //Changes have not been saved yet
        this.checked = false;

        //Send to server
        axios({ method: "PUT", "url": process.env.VUE_APP_API_PATH + "user/" + this.user.id, data: this.user })
          .then(result => {
            //Changes have been saved
            this.checked = true;
          }, error => {
            //Changes have not been saved
            console.error(error);
            this.checked = false;
          });
      },
      createUser: function (event) {
        axios({ method: "POST", "url": process.env.VUE_APP_API_PATH + "user/Create", data: this.user })
          .then(result => {
              console.log(result);
              this.$router.push({ query: {"userId": result.data.id }});
              this.$router.go();
            }, error => {
              console.log(error.response.data.errors);
              alert(JSON.stringify(error.response.data.errors));
          });
      }
    },
    mounted() {
      axios({
        method: "GET", url: process.env.VUE_APP_API_PATH + "socialInsuranceStatus/"
      }).then(result => {
        this.insuranceStati = result.data;
        this.insuranceStatiLoaded = true;
      }, error => {
        console.error(error);
          this.insuranceStatiLoaded = false;
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });

      //Load user
      this.userId = this.$route.query.userId;
      if(this.userId == null) {
        return;
      }

      axios({
        method: "GET", url: process.env.VUE_APP_API_PATH + "user/" + this.userId
      }).then(result => {
        this.user = result.data;
        this.dataLoaded = true;
      }, error => {
        console.error(error);
        this.dataLoaded = false;
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });
    }
  };
</script>
